import clsx from 'clsx'
import ChevronIcon from '@ancon/wildcat-ui/shared/icons/dropdown-arrow.svg'

import HeadingText from '../../../app/components/HeadingText'
import BodyText from '../../../app/components/BodyText'
import InteractiveDiv from '../../../layout/components/InteractiveDiv'
import { CapacityConflictOptionType } from '../../types'

import styles from './CapacityConflictOptionRow.module.scss'
import CapacityConflictVisualIcon from './CapacityConflictVisualIcon'

type CapacityConflictOptionRowProps = {
  variant: CapacityConflictOptionType
  title: string
  subtitle: string
  onClick: () => void
}

export default function CapacityConflictOptionRow({
  variant,
  title,
  subtitle,
  onClick,
}: CapacityConflictOptionRowProps) {
  return (
    <InteractiveDiv
      className={clsx(styles.row, {
        [styles.rowDelete]: variant === CapacityConflictOptionType.DeleteOrder,
      })}
      tabIndex={0}
      onClick={onClick}
    >
      <CapacityConflictVisualIcon variant={variant} />
      <div className={styles.textWrap}>
        <HeadingText as="span" size="h3" className={styles.title}>
          {title}
        </HeadingText>
        <BodyText as="span" className={styles.subtitle} color="body-2">
          {subtitle}
        </BodyText>
      </div>
      <ChevronIcon className={styles.chevron} />
    </InteractiveDiv>
  )
}
